import { store } from "src/store/store";
import { enableDebugChanged } from "src/duck/actions";
import { getIsDebugEnabled } from "src/duck/selectors";

function getIsEnabled() {
  const state = store.getState();
  return getIsDebugEnabled(state);
}

export default function enableDebugSettings() {
  let timesPressed = 0;
  let timeoutId;

  function reset() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    timeoutId = setTimeout(() => {
      timesPressed = 0;
    }, 5000);
  }

  return () => {
    reset();
    timesPressed++;
    if (timesPressed === 5) {
      const update = !getIsEnabled();
      store.dispatch(enableDebugChanged(update));
    }
  };
}
